<template>
  <div>
    <h2>您将需要 <span>{{this.total}}</span> 个课时完成 {{ this.$route.query.course_name }} 的学习</h2>
    <div class="operationBtn">
        <el-button type="primary" icon="el-icon-top" class="backBtn" @click="goback()">课程目录</el-button>
        <!-- <el-button type="primary" icon="el-icon-refresh" class="refreshBtn">刷新</el-button> -->
    </div>
    <div class="LessonList">
      <el-backtop></el-backtop>
      <!-- <h3>我的课程</h3> -->
      <!-- <el-image v-for="lesson in lessonsList" :key="lesson.id" :src="lesson.topic_front_image" lazy @click="goCoursePage(lesson.course_name, lesson.id)"></el-image> -->
      <img v-for="lesson in lessonsList" :key="lesson.id" v-lazy="lesson.topic_front_image" @click="goCoursePage(lesson.course_name, lesson.id)" />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      queryInfo: {
        course_id: this.$route.query.course_id,
        course_name: this.$route.query.course_name,
        token: ''
      },
      lessonsList: [],
      total: 0
    }
  },
  created () {
    this.queryInfo.token = window.sessionStorage.getItem('token')
    // this.queryInfo.course_name = this.$route.query.course_name
    this.getLessonsList()
  },
  methods: {
    async getLessonsList () {
      const { data: res } = await this.$http.get('app/lessons/', { params: this.queryInfo })
      this.lessonsList = res
      this.total = res.length
      console.log(res)
      if (res.total === 0) return this.$notify({ title: '失败', message: '获取课程章节失败!' + ' -' + res.msg, type: 'error' })
      this.$notify({ title: '成功', message: '获取课程章节成功', type: 'success' })
    },
    goCoursePage (courseId, lessonId) {
      console.log('course_id', courseId)
      console.log('lesson_id', lessonId)
      // this.$router.push('/page')
      this.$router.push({ path: '/page', query: { course_id: courseId, lesson_id: lessonId } })
    },
    goback () {
      this.$router.back()
    }
  }
}
</script>

<style lang="less" scoped>
.operationBtn{
  display: flex;
  justify-content: space-between;
  text-align: center;
  // position: relative;
  .backBtn{
    position: fixed;
    left: 20px;
    z-index: 9999;
  }
}
.LessonList{
    display: flex;
    // flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    padding-top: 10px;
    align-items: center;
    margin-top: 50px;
    > img{
      justify-content: center;
      flex-wrap: wrap;
      width: 220px;
      cursor: pointer;
      padding: 5px;
    }
  }
  .el-image{
    padding-right: 20px !important;
    width: 220px;
    cursor: pointer;
  }
  h2{
    text-align: center;
  }
  h2 span{
    font-size: 50px;
    color: coral;
    font-weight: 600;
    }
</style>
